import { ReactNode } from 'react';
import { useRive, Layout, Fit, Alignment } from '@rive-app/react-webgl2';

import styles from './EmptyPlaceholder.module.css';

type Props = {
  text: string;
  children?: ReactNode | null;
};

export default function EmptyPlaceholder({ text, children }: Props) {
  const { RiveComponent } = useRive({
    src: '/static/riv/robot_cleaner_crop_2.riv',
    animations: ['Test', 'dust_fly'],
    autoplay: true,
    layout: new Layout({ fit: Fit.FitWidth, alignment: Alignment.Center }),
  });

  return (
    <div className={styles.NoPostsContainer}>
      <div className={styles.AnimationContainer}>
        <RiveComponent />
      </div>
      <p className={styles.NoPostsCaption}>{text}</p>
      {children && <div className={styles.ChildrenContainer}>{children}</div>}
    </div>
  );
}
